export const INITIAL_FORM_DATA = {
  accountOwner: "",
  accountNumber: "",
  amount: 0,
  bankName: "",
  bankId: "",
  beneficiaryAccountNumber: "",
  beneficiaryName: "",
  categoryId: "",
  categoryName: "",
  description: "",
} as const;

export const INITIAL_FORM_ERRORS = {
  beneficiaryAccountNumber: {
    message: "",
    hasError: false,
  },
  bankName: {
    message: "",
    hasError: false,
  },
  beneficiaryName: {
    message: "",
    hasError: false,
  },
  amount: {
    message: "",
    hasError: false,
  },
} as const;

export const TRANSFER_OPTIONS = {
  BANK: "bank" as const,
  WALLET: "wallet" as const,
};

export const ERROR_MESSAGES = {
  ACCOUNT_NUMBER_REQUIRED: "Account number is required",
  ACCOUNT_NUMBER_INVALID: "Account number must be 10 digits",
  AMOUNT_REQUIRED: "Amount is required",
  AMOUNT_ZERO: "Amount must be greater than zero",
  INSUFFICIENT_FUNDS: "Insufficient funds",
  INSUFFICIENT_BALANCE: "Insufficient balance",
  SELECT_BANK_FIRST: "Please select a bank first",
  INVALID_WALLET: "Invalid wallet account number",
  NO_BENEFICIARY_FOUND:
    "No beneficiary was found. Please verify account number and/or bank name.",
  BANK_REQUIRED: "Please select a bank first",
  DEBIT_LIMIT_BREACH:
    "Sorry we are unable to proceed with this transaction, kindly review the amount you intend to send",
  SAME_ACCOUNT_TRANSFER: "You cannot send money to your own account",
};
